import { FetchLike, createClient, getRepositoryEndpoint } from '@prismicio/client'
import { fetchWithAgent } from '@dtx-company/inter-app/src/services/fetch-agent'

const PrismicEndpoint = getRepositoryEndpoint('flowcode-ui')

export const prismicClient = createClient(PrismicEndpoint, { fetch: fetchWithAgent as FetchLike })

export type Indexable<T> = T & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

/**  @deprecated - Cache is no longer needed  */
export const prismicCachedImage = (url: string): string => url
